import { ajaxInstance} from "../utils/axios";


export default function useIbs(){
    let getAllIbsUrl = `api/ibs/list`
    let sendIbFileUrl = `/api/ibs/store`
    let modifyIbUrl = `/api/ibs/edit`
    let createIbUrl = `/api/ibs/create`
    let getIbEarningsUrl = `/api/ibs/earnings`
    let getIbRegistrationsUrl = `/api/ibs/registrations`
    let getIbCountriesUrl = `api/ibs/countries`
    let getIbAssetsUrl = `api/ibs/assets`


    const getAllIbs = (currentPage, size=null, search=null, onlyUsers=false) => {
        let params = {
            ...(currentPage !== null && {page: currentPage}),
            ...(size !== null && {size: size}),
            ...(search !== null && {search: search}),
            ...(onlyUsers !== null && {onlyUsers: onlyUsers})
        }
        return new Promise((resolve, reject) => {
            ajaxInstance.get(getAllIbsUrl, { params: params
            }).then((response) => {
                const data = response.data
                console.log('Get IbHook', data.data)
                if (response.status === 200){
                    resolve(data.data)
                }
            }).catch((error) => {
                if (error.response.status !== 500){
                    const data = error.response.data
                    const errors = data.errors
                    console.log('Error in get IbHook', errors)
                    reject()
                }else{
                    console.log('Error in get IbHook', error)
                    reject()
                }
            })
        })
    }
    const uploadIbsFile = (file) => {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append('file', file[0])
            ajaxInstance.post(
                sendIbFileUrl,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then((response) => {
                const data = response.data
                console.log('Post IbHook', data.data)
                if (response.status === 200){
                    resolve(data.data)
                }
            }).catch((error) => {
                console.log(error)
                if (error.response.status !== 500){
                    const data = error.response.data
                    const errors = data.errors
                    console.log('Error in post IbHook', errors)
                    reject(errors)
                }else{
                    console.log('Error in post IbHook', error)
                    reject('Ocurrió un problema')
                }
            })
        })
    }

    const modifyIbData = (data) => {
        return new Promise((resolve, reject) => {
            ajaxInstance.put(
                modifyIbUrl,
                data,
            ).then((response) => {
                const data = response.data
                console.log('Put IbHook', data.data)
                if (response.status === 200){
                    resolve(data.data)
                }
            }).catch((error) => {
                console.log(error)
                if (error.response.status !== 500){
                    const data = error.response.data
                    const errors = data.errors
                    console.log('Error in put IbHook', errors)
                    reject(errors)
                }else{
                    console.log('Error in put IbHook', error)
                    reject('Ocurrió un problema')
                }
            })
        })
    }

    const createIb = (ibFormData) => {
        return new Promise((resolve, reject) => {
            ajaxInstance.post(
                createIbUrl,
                ibFormData,
            ).then((response) => {
                const data = response.data
                console.log('Post IbHook', data.data)
                if (response.status === 200){
                    resolve(data.data)
                }
            }).catch((error) => {
                console.log(error)
                if (error.response.status !== 500){
                    const data = error.response.data
                    const errors = data.errors
                    console.log('Error in post IbHook', errors)
                    reject(errors)
                }else{
                    console.log('Error in post IbHook', error)
                    reject('Ocurrió un problema')
                }
            })
        })
    }
    const getIbEarnings = (ibNumber) => {
        let queryUrl = getIbEarningsUrl + `?ibNumber=${ibNumber}`
        return new Promise((resolve, reject) => {
            ajaxInstance.get(
                queryUrl
            ).then((response) => {
                const data = response.data
                if(response.status === 200){
                    resolve(data.data)
                }
            }).catch((error) => {
                console.log(error)
                if (error.response.status !== 500){
                    const data = error.response.data
                    const errors = data.errors
                    reject(errors)
                }else{
                    reject('Ocurrió un problema')
                }
            })
        })
    }
    const getIbsRegistrationsByCountry = (ibNumber) => {
        let queryUrl = getIbRegistrationsUrl  + `?ibNumber=${ibNumber}`
        return new Promise((resolve, reject) => {
            ajaxInstance.get(
                queryUrl
            ).then((response) => {
                const data = response.data
                if(response.status === 200){
                    resolve(data.data)
                }
            }).catch((error) => {
                console.log(error)
                if (error.response.status !== 500){
                    const data = error.response.data
                    const errors = data.errors
                    reject(errors)
                }else{
                    reject('Ocurrió un problema')
                }
            })
        })
    }
    const getIbsCountries = (ibNumber) => {
        let queryUrl = getIbCountriesUrl  + `?ibNumber=${ibNumber}`
        return new Promise((resolve, reject) => {
            ajaxInstance.get(
                queryUrl
            ).then((response) => {
                const data = response.data
                if(response.status === 200){
                    resolve(data.data)
                }
            }).catch((error) => {
                console.log(error)
                if (error.response.status !== 500){
                    const data = error.response.data
                    const errors = data.errors
                    reject(errors)
                }else{
                    reject('Ocurrió un problema')
                }
            })
        })
    }

    const getIbPopularAssets = (ibNumber) => {
        let queryUrl = getIbAssetsUrl  + `?ibNumber=${ibNumber}`
        return new Promise((resolve, reject) => {
            ajaxInstance.get(
                queryUrl
            ).then((response) => {
                const data = response.data
                if(response.status === 200){
                    resolve(data.data)
                }
            }).catch((error) => {
                console.log(error)
                if (error.response.status !== 500){
                    const data = error.response.data
                    const errors = data.errors
                    reject(errors)
                }else{
                    reject('Ocurrió un problema')
                }
            })
        })
    }

    return {
        getAllIbs,
        getIbsRegistrationsByCountry,
        getIbsCountries,
        uploadIbsFile,
        modifyIbData,
        createIb,
        getIbEarnings,
        getIbPopularAssets
    }

}